var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3, _react_refresh_temp_4;
var _react_refresh_temp_5;
_react_refresh_temp_5 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Menu } from '@headlessui/react';
import { createSelector } from '@reduxjs/toolkit';
import { Track } from 'livekit-client';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../store';
import { updateSelectedAudioDevice } from '../../../../store/slices/roomSettingsSlice';
import { updateIsActiveMicrophone, updateIsMicMuted, } from '../../../../store/slices/bottomIconsActivitySlice';
const audioDevicesSelector = createSelector(_react_refresh_temp_1 = (state) => state.roomSettings, (roomSettings) => roomSettings.audioDevices);
$RefreshReg$(_react_refresh_temp_1, "audioDevicesSelector$createSelector");
const isMicMutedSelector = createSelector(_react_refresh_temp_2 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.isMicMuted);
$RefreshReg$(_react_refresh_temp_2, "isMicMutedSelector$createSelector");
const selectedAudioDeviceSelector = createSelector(_react_refresh_temp_3 = (state) => state.roomSettings, (roomSettings) => roomSettings.selectedAudioDevice);
$RefreshReg$(_react_refresh_temp_3, "selectedAudioDeviceSelector$createSelector");
const MicMenuItems = ({ currentRoom }) => {
    _react_refresh_temp_5();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const audioDevices = useAppSelector(audioDevicesSelector);
    const isMicMuted = useAppSelector(isMicMutedSelector);
    const selectedAudioDevice = useAppSelector(selectedAudioDeviceSelector);
    const [devicesMenu, setDevicesMenu] = useState();
    const [newDevice, setNewDevice] = useState();
    useEffect(() => {
        const devicesMenu = audioDevices.map((device) => {
            return (_jsx("div", { className: "", role: "none", children: _jsx(Menu.Item, { children: () => (_jsx("p", { className: `${selectedAudioDevice === device.id
                            ? 'secondaryColor'
                            : 'text-gray-700 dark:text-darkText'} rounded group flex items-center px-3 py-[0.4rem] text-[10px] lg:text-xs transition ease-in hover:bg-primaryColor hover:text-white cursor-pointer`, onClick: () => setNewDevice(device.id), children: device.label })) }) }, device.id));
        });
        setDevicesMenu(devicesMenu);
    }, [audioDevices, selectedAudioDevice]);
    useEffect(() => {
        const changeDevice = async (id) => {
            await currentRoom.switchActiveDevice('audioinput', id);
        };
        if (newDevice) {
            changeDevice(newDevice);
            dispatch(updateSelectedAudioDevice(newDevice));
        }
    }, [newDevice, currentRoom, dispatch]);
    const muteUnmuteMic = () => {
        currentRoom === null || currentRoom === void 0 ? void 0 : currentRoom.localParticipant.audioTracks.forEach(async (publication) => {
            if (publication.track &&
                publication.track.source === Track.Source.Microphone) {
                if (publication.isMuted) {
                    await publication.track.unmute();
                    dispatch(updateIsMicMuted(false));
                }
                else {
                    await publication.track.mute();
                    dispatch(updateIsMicMuted(true));
                }
            }
        });
    };
    const leaveMic = () => {
        currentRoom === null || currentRoom === void 0 ? void 0 : currentRoom.localParticipant.audioTracks.forEach(async (publication) => {
            if (publication.track && publication.kind === Track.Kind.Audio) {
                currentRoom.localParticipant.unpublishTrack(publication.track, true);
            }
        });
        dispatch(updateIsActiveMicrophone(false));
        dispatch(updateIsMicMuted(false));
        dispatch(updateSelectedAudioDevice(''));
    };
    const menuItems = () => {
        return (_jsxs(Menu.Items, { static: true, className: "origin-bottom-right z-[9999] absolute ltr:left-0 rtl:-left-4 mt-2 w-40 bottom-[40px] rounded-md shadow-lg bg-white dark:bg-darkPrimary ring-1 ring-black dark:ring-secondaryColor ring-opacity-5 divide-y divide-gray-100 dark:divide-secondaryColor focus:outline-none", children: [devicesMenu, _jsx("div", { className: "", role: "none", children: _jsx(Menu.Item, { children: () => (_jsx("p", { className: "text-gray-700 dark:text-darkText rounded group flex items-center px-3 py-[0.4rem] text-xs transition ease-in hover:bg-primaryColor hover:text-white cursor-pointer", onClick: () => muteUnmuteMic(), children: isMicMuted
                                ? t('footer.menus.unmute-microphone')
                                : t('footer.menus.mute-microphone') })) }) }), _jsx("div", { className: "", role: "none", children: _jsx(Menu.Item, { children: () => (_jsx("p", { className: "text-red-900 group flex rounded-md items-center text-left w-full px-2 py-[0.4rem] text-xs transition ease-in hover:bg-red-400 hover:text-white cursor-pointer", onClick: () => leaveMic(), children: t('footer.menus.leave-microphone') })) }) })] }));
    };
    return _jsx(_Fragment, { children: menuItems() });
};
_react_refresh_temp_4 = MicMenuItems;
$RefreshReg$(_react_refresh_temp_4, "MicMenuItems");
_react_refresh_temp_5(MicMenuItems, "LeWARz7izxOn8wFYKqB4NhcyS2Y=", false, () => [useAppDispatch, useTranslation, useAppSelector, useAppSelector, useAppSelector]);
export default MicMenuItems;
